import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

/**
 * What a page adds to the top bar of a recommended automation's tile, such as Home's picker of the stage the person
 * has taken one of their own automations to. Nothing for an automation the page has no action for, and tiles opened
 * outside such a page show none.
 */
export type AutomationRecommendationHeaderAction = (automation: {
    readonly automationId: string;
    readonly taskId: string;
}) => ReactNode;

const AutomationRecommendationHeaderActionContext = createContext<AutomationRecommendationHeaderAction | null>(null);

export const AutomationRecommendationHeaderActionProvider = AutomationRecommendationHeaderActionContext.Provider;

export const useAutomationRecommendationHeaderAction = (): AutomationRecommendationHeaderAction | null =>
    useContext(AutomationRecommendationHeaderActionContext);
